/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Error_Name_MinInputs */

const vi_customer_error_name_min = /** @type {(inputs: Customer_Error_Name_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên khách hàng phải ít nhất 2 ký tự`)
};

/**

* @param {Customer_Error_Name_MinInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_error_name_min = /** @type {((inputs?: Customer_Error_Name_MinInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Error_Name_MinInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_error_name_min(inputs)
});